<template>
  <z-form ref="form" :show-state="true" @submit.prevent.native="save">
    <div class="col-12">
      <div class="row">
        <div class="z-card border-0">
          <div class="row">
            <div class="col-6">
              <div ref="form" class="z-card" :show-state="true">
                <h4>{{ $t('pbx.time-condition.form.title.edit.main') }}</h4>

                <div class="z-card__body">
                  <z-form-group class="row">
                    <label class="col-2 text-right">
                      {{ $t('shared.component.table.field.title') }}
                    </label>

                    <div class="col-10">
                      <z-form-input :rules="{ required: true }">
                        <i-input v-model="form.name" :clearable="true" />
                      </z-form-input>
                    </div>
                  </z-form-group>

                  <z-form-group class="row">
                    <label class="col-2 text-right">
                      {{ $t('shared.component.table.field.time_zone') }}
                    </label>

                    <div class="col-10">
                      <z-form-input :rules="{ required: true }">
                        <time-zone-select v-model="form.timezone" />
                      </z-form-input>
                    </div>
                  </z-form-group>

                  <z-form-group v-if="modify_work_time.length" class="row">
                    <div class="offset-2 col-10">
                      <work-time-form v-model="modify_work_time" />
                    </div>
                  </z-form-group>

                  <z-form-group class="row">
                    <div class="offset-2 col-10">
                      <i-button
                        type="default"
                        icon="md-add"
                        long
                        size="large"
                        @click="create_time_interval"
                      >
                        {{ $t('pbx.time-condition.form.buttons.create_time_interval') }}
                      </i-button>
                    </div>
                  </z-form-group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <i-button type="primary" html-type="submit" size="large" :loading="is_loading">
          {{ $t('shared.component.button.save') }}
        </i-button>
      </div>
    </div>
  </z-form>
</template>
<script>
  import defaultsDeep from 'lodash-es/defaultsDeep';
  import cloneDeep from 'lodash-es/cloneDeep';
  import pick from 'lodash-es/pick';
  import TimeZoneSelect from '@shared/components/input/input-timezone-select';
  import WorkTimeForm from './_fragments/worktime-form';
  import { TimeConditionModalService } from '@pbx/modals/TimeConditionModalService';
  import { TimeConditionService } from '@pbx/services/TimeConditionService';
  import { WorkTimeService } from '@pbx/services/WorkTimeService';

  export default {
    components: {
      TimeZoneSelect,
      WorkTimeForm
    },
    props: {
      id: {
        type: [Number, String],
        default: null
      },

      item: {
        type: Object,
        default: null
      },

      work_time: {
        type: Array,
        default: () => []
      }
    },

    data: () => ({
      form: {},
      modify_work_time: [],
      is_loading: false
    }),

    watch: {
      item: {
        handler: function (val) {
          this.form = defaultsDeep(val, {
            name: '',
            timezone: this.$user.timezone
          });
        },
        immediate: true
      },

      work_time: {
        handler: function (work_time) {
          this.modify_work_time = cloneDeep(work_time) || [];
        },
        immediate: true
      }
    },

    methods: {
      save() {
        
        this.$refs.form.validate().then((is_valid) => {
          if (is_valid) {
            this.is_loading = true;

            const form = pick(this.form, ['name', 'timezone']);
            const request = Number.isInteger(parseInt(this.id))
              ? TimeConditionService.editItem(this.id, form)
              : TimeConditionService.createItem(form);

            request
              .then((time_condition_item) =>
                Promise.all([
                  time_condition_item,
                  WorkTimeService.removeAll(time_condition_item.id)
                ])
              )
              .then((response) => {
                const time_condition = response[0];
                const create_all_modify_work_time_requests = this.modify_work_time.map((a) =>
                  WorkTimeService.createItem(time_condition.id, a)
                );
                return Promise.all(create_all_modify_work_time_requests);
              })
              .then(() => this.$router.push({ name: 'pbx.time-condition.index' }))
              .finally(() => (this.is_loading = false));
          }
        });
      },

      create_time_interval: function () {
        TimeConditionModalService.create_time_interval().on(
          'success',
          (items) => (this.modify_work_time = [...this.modify_work_time, ...cloneDeep(items)])
        );
      }
    }
  };
</script>
